<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<ng-container *ngIf="loadInfo">
  <p class="text-info">"Sleep Hygiene Index" (SHI)</p>
  <p class="text-info">
    A continuación encontrarás una lista de declaraciones.
    Por favor califica qué tan cierta es cada una de ellas para ti.
  </p>

  <div nz-row class="mt-xs mb-md tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-w-full">
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">1. Nunca</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">2. Raramente</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">3. A veces</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">4. Frecuente</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">5. Siempre</p>
    </div>
  </div>

  <form [formGroup]="form" novalidate nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" *ngIf="loadInfo">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col [nzSpan]="24" class="mb-sm">
        <div class="shi-container">
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">1. Duermo siestas de dos o más horas durante el día.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="takeNapsTwoOrMoreHours" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
              <!-- <i nz-icon nzType="frown" [class.icon-highlight]="preHighLight"></i>
              <i nz-icon nzType="smile" [class.icon-highlight]="nextHighLight"></i> -->
            </div>
            <div>
              <p class="text-info">{{ this.form.get('takeNapsTwoOrMoreHours').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('takeNapsTwoOrMoreHours')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">2. Me voy a la cama en horarios diferentes de un día a otro.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="goToBedAtDifferentTimes" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('goToBedAtDifferentTimes').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('goToBedAtDifferentTimes')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">3. Me levanto de la cama en horarios diferentes de un día a otro.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="getUpBedAtDifferentTimes" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('getUpBedAtDifferentTimes').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('getUpBedAtDifferentTimes')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">4. Hago ejercicio hasta sudar 1 hora antes de irme a la cama.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="workUpSweatOneHourBeforeBed" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('workUpSweatOneHourBeforeBed').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('workUpSweatOneHourBeforeBed')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">5. Me quedo en la cama más de lo debido dos o tres veces por semana.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="stayInBedMoreTwoOrThreeTimesAWeek" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('stayInBedMoreTwoOrThreeTimesAWeek').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('stayInBedMoreTwoOrThreeTimesAWeek')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">6. Consumo alcohol, tabaco o cafeína dentro de 4 horas antes de acostarme o después de acostarme.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="useAlcoholTobaccoOrCaffeineBeforeOrAfterBed" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('useAlcoholTobaccoOrCaffeineBeforeOrAfterBed').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('useAlcoholTobaccoOrCaffeineBeforeOrAfterBed')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">7. Hago algo que pueda despertarme antes de acostarme (por ejemplo: jugar videojuegos, usar Internet o limpiar).</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="doSomethingBeforeBedThatMightWakeMeUp" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('doSomethingBeforeBedThatMightWakeMeUp').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('doSomethingBeforeBedThatMightWakeMeUp')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">8. Me voy a la cama sintiéndome estresado, enojado, molesto o nervioso.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="goToBedFeelingStressedAngryUpsetOrNervous" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('goToBedFeelingStressedAngryUpsetOrNervous').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('goToBedFeelingStressedAngryUpsetOrNervous')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">9. Uso mi cama para otras cosas además de dormir o tener sexo (por ejemplo: ver televisión, leer, comer o estudiar).</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="useBedForOtherThingsThanSleepingOrHavingSex" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('useBedForOtherThingsThanSleepingOrHavingSex').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('useBedForOtherThingsThanSleepingOrHavingSex')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">10. Duermo en una cama incómoda (ejemplo: un mal colchón o almohada y/o demasiadas o pocas cobijas).</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="sleepOnAnUncomfortableBed" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('sleepOnAnUncomfortableBed').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('sleepOnAnUncomfortableBed')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">11. Duermo en una habitación incómoda (ejemplo: demasiado iluminada, caliente, fría, ruidosa o llena de cosas).</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="sleepInAnUncomfortableRoom" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('sleepInAnUncomfortableRoom').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('sleepInAnUncomfortableRoom')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">12. Hago un trabajo importante antes de acostarme (ejemplo: pago de cuentas, planeación de agenda o estudio).</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="doSomeImportantWorkBeforeGoingToBed" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('doSomeImportantWorkBeforeGoingToBed').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('doSomeImportantWorkBeforeGoingToBed')"></app-message-field>
          </div>
          <div class="shi-item">
            <div class="input-label-form tw-h-3/6">13. Pienso, planifico o me preocupo cuando estoy en la cama.</div>
            <div class="tw-flex tw-items-center tw-h-3/6">
              <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="thinkPlanOrWorryWhenIAmInBed" [nzMarks]="marks" [nzMin]="1" [nzMax]="5" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
            </div>
            <div>
              <p class="text-info">{{ this.form.get('thinkPlanOrWorryWhenIAmInBed').value | getSleepStatus}}</p>
            </div>
            <app-message-field [field]="form.get('thinkPlanOrWorryWhenIAmInBed')"></app-message-field>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
    <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
  </div>
</ng-container>
